import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    show: { type: Boolean, default: false },
  },

  methods: {
    ...mapMutations(['allowLeavingModal', 'preventLeavingModal']),

    /**
     * Prevent accidental abandonment only if form was changed.
     */
    updateModalStatus() {
      this.preventLeavingModal()
    },

    /**
     * Show the custom abandonment dialog before closing a modal.
     *
     * @param {Function} proceed
     * @param {Function} revert
     * @returns {void}
     */
    handlePreventModalAbandonment(proceed, revert) {
      if (this.canLeaveModal) {
        proceed()
        return
      }

      revert()

      Nova.$emit('confirm-form-abandonment', {
        proceed: () => {
          this.allowLeavingModal()
          proceed()
        },
        revert: () => {},
      })
    },
  },

  computed: {
    ...mapGetters(['canLeaveModal']),
  },
}
